export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    slug: 'wanfa-guize',
    name: '玩法规则',
    description: '澳门彩各类玩法详细介绍与规则说明',
    icon: 'ri-book-open-line',
  },
  {
    slug: 'kaijiang-jieguo',
    name: '开奖结果',
    description: '最新澳门彩开奖号码与历史开奖记录查询',
    icon: 'ri-numbers-line',
  },
  {
    slug: 'goumai-jiqiao',
    name: '购买技巧',
    description: '专业澳门彩购买策略与投注技巧分享',
    icon: 'ri-lightbulb-line',
  },
  {
    slug: 'zhongjiang-gonglve',
    name: '中奖攻略',
    description: '澳门彩中奖经验总结与实战攻略指南',
    icon: 'ri-trophy-line',
  },
  {
    slug: 'kaijiang-shijian',
    name: '开奖时间',
    description: '澳门彩各彩种开奖时间表与日程提醒',
    icon: 'ri-time-line',
  },
  {
    slug: 'haoma-fenxi',
    name: '号码分析',
    description: '澳门彩号码走势分析、冷热号统计与预测',
    icon: 'ri-line-chart-line',
  },
];